import {FormGroup, ValidatorFn, Validators} from '@angular/forms';

export interface IRegistrationFormValidatorList{
    [key:string]: ValidatorFn | ValidatorFn[]
}

export const UserRegistrationValidators:IRegistrationFormValidatorList ={
    name:[Validators.required],
    email: [Validators.required, Validators.email],
    // No edge whitespace and a space is not the symbol: the change-password API trims its fields, login does not.
    password: Validators.compose([Validators.required, Validators.pattern(/^(?=.*\p{Ll})(?=.*\p{Lu})(?=.*\d)(?=.*[^\p{L}\p{N}\s])(?!\s)(?!.*\s$).{8,}$/u)]),
    terms:[Validators.pattern('true')]

}
export const passwordsMustMatch: (passwordField:string, confirmPasswordField:string)=> ValidatorFn = (passwordField:string, confirmPasswordField:string) =>{
    return (control:FormGroup)=>{
      const password = control?.get(passwordField)?.value;
      const confirmPassword = control?.get(confirmPasswordField)?.value;

      if(password?.length > 0 && confirmPassword?.length > 0) {
          return password === confirmPassword
              ? null
              :{
                passwordsMustMatch:true
              }
        }

      return null;
    }

}

export const hasAtListOneItemInArray: () => ValidatorFn = () =>{
    return (control:FormGroup)=>{
      return Array.isArray(control?.value) && control.value?.length > 0
            ? null
            :{
                hasAtListOneItemInArray:true
            }
    }

}